import "./currentTicketReport.scss";
import { Dispatch, SetStateAction, useState, useEffect, useRef, useCallback } from "react";
import moment from "moment";
import api, { API_URI } from "api";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";

function CurrentTicketReport({ open, setOpen }: { open: boolean; setOpen: Dispatch<SetStateAction<boolean>> }) {
    const params: any = useParams();
    const [members, setMembers] = useState<any>([]);
    const dateFromRef = useRef<HTMLInputElement>(null);
    const [report, setReport] = useState<{ dateFrom: string; dateTo: string }>({
        dateFrom: "",
        dateTo: "",
    });

    const [reportFiles, setReportFiles] = useState<string[]>([]);

    const getFileReports = async () => {
        var files = await api.report.getminiofiles(params.boardId);
        setReportFiles(files);
    };

    const downloadFile = async (filename: string) => {
        let fn = filename;
        await api.report.downloadReport(filename).then(function (data) {
            var binaryString = window.atob(data.File);
            var binaryLen = binaryString.length;
            var bytes = new Uint8Array(binaryLen);
            for (var i = 0; i < binaryLen; i++) {
                var ascii = binaryString.charCodeAt(i);
                bytes[i] = ascii;
            }
            data.OwnFileName = fn;
            var blob = new Blob([bytes], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
            var link = document.createElement("a");
            link.setAttribute("target", "_blank");
            link.href = window.URL.createObjectURL(blob);
            link.download = data.OwnFileName;
            link.click();
        });
    };

    const generateReport = () => {
        api.report.generate(params.boardId);
        setOpen(false);
        toast.info("The report was requested and will re-appear in the list once generated");
    };

    const getMembers = useCallback(() => {
        api.board.member.getAll(params.boardId).then((data) => {
            setMembers(
                data.map((member: any) => {
                    return {
                        Id: member.Id,
                        Name: member.Name,
                        Surname: member.Surname,
                        Selected: true,
                    };
                })
            );
        });
    }, [params.boardId]);

    useEffect(() => {
        getMembers();
    }, [getMembers]);

    useEffect(() => {
        getFileReports();
        console.log("fire");
    }, [open]);

    return (
        <div id="CurrentTicketReport">
            <div className={`current-ticket-report ${open ? "open" : ""}`} onClick={(e) => e.stopPropagation()}>
                {/* <div className="input-group"> */}
                <table>
                    <thead>
                        <tr>
                            <th>File Name</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {reportFiles.length === 0 ? (
                            <h1>No recent reports found</h1>
                        ) : (
                            reportFiles.map((x, i) => (
                                <tr>
                                    <td>{x.substring(x.lastIndexOf("/") + 1)}</td>
                                    <td>
                                        <i className="fa-regular fa-file-arrow-down" onClick={() => downloadFile(x)}></i>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
                {/* </div> */}
                <button onClick={generateReport}>Generate Latest Report</button>
            </div>
        </div>
    );
}

export default CurrentTicketReport;
